import APIConnection from '@/API/APIConnection';
export default {
    create(data){
        return APIConnection.post('events', data);
    },
    viewPage(link){
        return APIConnection.post('events/view/page', {link: link});
    }
}